import { AnalyticsEvent } from '@guardfinder/analytics';

import { JobId } from '../../../job';

export class JobSubmittedEvent extends AnalyticsEvent {
    constructor(jobID: JobId) {
        super('job-submit-success', {
            'job-id': jobID.id
        });
    }
}
